import { render, staticRenderFns } from "./ParcelFormComponent.vue?vue&type=template&id=7cbc7b2b"
import script from "./ParcelFormComponent.vue?vue&type=script&lang=js"
export * from "./ParcelFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports